//LIBRARIES
import styled, { css } from "styled-components";
import Button from "@mui/material/Button";

//MISC
import { COLORS, FONTS } from "constants/styleVariables";

export const ArrowUp = styled.div`
  width: 0;
  height: 0;
  border-left: 6px solid transparent;
  border-right: 6px solid transparent;
  border-bottom: 7px solid #B0B3BF;
  margin-bottom: 3px;
  ${props => props.active && css`
    border-bottom: 7px solid #293462;
  `}
`;

export const ArrowDown = styled.div`
    width: 0;
    height: 0;
    border-left: 6px solid transparent;
    border-right: 6px solid transparent;
    border-top: 7px solid #B0B3BF;
    ${props => props.active && css`
    border-top: 7px solid #293462;
  `}
`;

export const ArrowsContainer = styled.div`
  display: inline-flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  vertical-align: middle;
  margin-bottom: 2px;
  margin-left: 10px;
`;

export const ArrowsContainerDate = styled.div`
  display: inline-flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  vertical-align: middle;
  margin-bottom: 2px;
`;